var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Divider from '../../../components/Divider';
import CurrencyFormatter from '../../../core/utils/currency-formatter';
import CouponForm from './CouponForm';
import { getCartTotal } from '../../../core/helpers/cart-helper';
import { getEstimatedDateFrom, getEstimatedDateTo } from '../../../core/helpers/delivery-helper';
var mapStateToProps = function (state) { return ({
    shippingFee: state.cart.shippingFee,
}); };
var connector = connect(mapStateToProps, {});
var CheckoutTotal = /** @class */ (function (_super) {
    __extends(CheckoutTotal, _super);
    function CheckoutTotal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckoutTotal.prototype.render = function () {
        return (React.createElement("div", { className: "c-checkout-total" },
            React.createElement(Divider, null),
            React.createElement("div", { className: "c-checkout-total__shipping" },
                React.createElement("div", { className: "c-checkout-total__shipping__left" },
                    React.createElement("h1", null, this.props.t('cart.delivery.title')),
                    this.props.shippingAddress && (React.createElement("p", null, this.props.t('cart.delivery.estimation', {
                        fromDate: getEstimatedDateFrom(this.props.shippingAddress.country_id),
                        toDate: getEstimatedDateTo(this.props.shippingAddress.country_id),
                    })))),
                React.createElement("div", { className: "c-checkout-total__shipping__right" }, this.props.shippingFee.shippingFee ? CurrencyFormatter.format(this.props.shippingFee.shippingFee) : this.props.t('cart.delivery.free'))),
            this.props.coupon && (React.createElement("div", { className: "c-checkout-total__coupon" },
                React.createElement(CouponForm, null))),
            React.createElement("div", { className: "c-checkout-total__summary" },
                React.createElement("h1", null, this.props.t('cart.total')),
                React.createElement("span", null, CurrencyFormatter.format(getCartTotal(this.props.items, this.props.coupon, this.props.shippingFee.shippingFee))))));
    };
    return CheckoutTotal;
}(React.Component));
export default connector(withTranslation()(CheckoutTotal));
